// extracted by mini-css-extract-plugin
module.exports = {"page":"page_page__M5MRx","title-wrapper":"page_title-wrapper__FBE_F","iframeContainer":"page_iframeContainer___597k","iframe":"page_iframe__xyzND"};